import React from 'react'
import styled from 'styled-components'
import Button from '../../../components/buttons/buttons.component'
import Modal from '../../../components/modal/modal.component'

const StyledModalContainer = styled.div`
	display: flex;
	flex-direction: column;

	.button-modal {
		align-self: flex-end;
	}

	@media screen and (max-width: 700px) {
		.button-modal {
			margin-top: 25px;
			width: 100%;
		}
	}
`

export default class ModalNotVerified extends React.Component {
	render() {
		const { isOpen, onClose, onConfirm } = this.props
		return (
			<Modal
				isOpen={isOpen}
				title={'Confirmação de cadastro'}
				medium
				onClose={onClose}>
				<StyledModalContainer>
					<p>
						O seu cadastro está pendente de confirmação. Clique no botão
						abaixo para reenviar o e-mail de confirmação.
					</p>
					<Button
						primary
						onClick={onConfirm}
						className={'button-modal'}
						type={'button'}>
						Reenviar
					</Button>
				</StyledModalContainer>
			</Modal>
		)
	}
}
